/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rental_DepartureInputs */

const en_rental_departure = /** @type {(inputs: Rental_DepartureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Departure`)
};

const es_rental_departure = /** @type {(inputs: Rental_DepartureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salida`)
};

const fr_rental_departure = /** @type {(inputs: Rental_DepartureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Départ`)
};

const de_rental_departure = /** @type {(inputs: Rental_DepartureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abreise`)
};

const id_rental_departure = /** @type {(inputs: Rental_DepartureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keberangkatan`)
};

/** @type {(inputs: Rental_DepartureInputs) => LocalizedString} */
const ja_rental_departure = en_rental_departure;

/** @type {(inputs: Rental_DepartureInputs) => LocalizedString} */
const zh_rental_departure = en_rental_departure;

/** @type {(inputs: Rental_DepartureInputs) => LocalizedString} */
const ar_rental_departure = en_rental_departure;

/** @type {(inputs: Rental_DepartureInputs) => LocalizedString} */
const it_rental_departure = en_rental_departure;

/** @type {(inputs: Rental_DepartureInputs) => LocalizedString} */
const ru_rental_departure = en_rental_departure;

/** @type {(inputs: Rental_DepartureInputs) => LocalizedString} */
const pt_rental_departure = en_rental_departure;

/** @type {(inputs: Rental_DepartureInputs) => LocalizedString} */
const ko_rental_departure = en_rental_departure;

/**
* | output |
* | --- |
* | "Departure" |
*
* @param {Rental_DepartureInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const rental_departure = /** @type {((inputs?: Rental_DepartureInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rental_DepartureInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rental_departure(inputs)
	if (locale === "es") return es_rental_departure(inputs)
	if (locale === "fr") return fr_rental_departure(inputs)
	if (locale === "de") return de_rental_departure(inputs)
	if (locale === "ja") return ja_rental_departure(inputs)
	if (locale === "zh") return zh_rental_departure(inputs)
	if (locale === "ar") return ar_rental_departure(inputs)
	if (locale === "id") return id_rental_departure(inputs)
	if (locale === "it") return it_rental_departure(inputs)
	if (locale === "ru") return ru_rental_departure(inputs)
	if (locale === "pt") return pt_rental_departure(inputs)
	return ko_rental_departure(inputs)
});